import { Container, ContainerManager } from 'statuo';

import { get as getPageOptions } from '../utilities/options';

import CoursesFilterContext from './models/Courses';
import TeetimesFilterContext from './models/Teetimes';

/* ========================================================================== */

export default new ContainerManager({
	courses: CoursesFilterContext,
	teetimes: TeetimesFilterContext,
	empty: Container
}, () => getPageOptions('filter-context') || 'empty');
